"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("hub-http/index");

var _promiseClient = _interopRequireDefault(require("hub-http/adapters/promiseClient"));

var _params = require("hub-http/helpers/params");

var core = _interopRequireWildcard(require("hub-http/middlewares/core"));

var hubapi = _interopRequireWildcard(require("hub-http/middlewares/hubapi"));

var debug = _interopRequireWildcard(require("hub-http/middlewares/debug"));

var externalAuth = _interopRequireWildcard(require("hub-http/middlewares/externalAuth"));

var formUrlencodedStack = (0, _index.createStack)(core.services, hubapi.defaults, debug.allowTimeoutOverride, core.bodyType('application/x-www-form-urlencoded', _params.stringify), core.httpsOnly, hubapi.hubapi, externalAuth.cookieAuthentication, core.withQuery, debug.rewriteUrl, hubapi.timeoutInQuery, core.reportOptionsError, hubapi.logoutOnUnauthorized, hubapi.retryOnError, core.validateStatus, core.jsonResponse);

var _default = (0, _promiseClient.default)(formUrlencodedStack);

exports.default = _default;
module.exports = exports.default;